import React, { useState, useRef, useEffect } from "react";
import axios from "../../wp-axios/axios";
import questionCircle from "./questionCircleDefault.svg";
import questionCircleHover from "./question-circle-hover.svg";
import rightArrow from "./arrow-right.svg";
import warningIcon from "./exclamation-circle.svg";
import { ASSET_PATH } from "../../utilities";

/**
 * Takes in a blob of text and returns the valid ISBNs and UPCs.
 * @param rawIsbnText The text blob to pull ISBNs and UPCs from.
 * @returns An array of all valid ISBN and UPC values in the text.
 */
const cleanIsbnText = (rawIsbnText) => {
    const strippedIsbnText = rawIsbnText.replace(/-/g, "");
    // Note: this does not support 10-digit ISBNs that end with an
    // 'X' character.
    const re_isbn = /(\d{9,})/g;
    const matches = strippedIsbnText.match(re_isbn);
    const matchArray = matches ? matches.filter((maybeIsbn) => maybeIsbn.length <= 17) : null;
    return matchArray !== null ? matchArray : [];
};

const EnterIsbns = (props) => {
    const [addingItems, setAddingItems] = useState(false);
    const [isbnText, setIsbnText] = useState(props.isbnText);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const inputRef = useRef();

    const onIsbnTextChange = (e) => {
        setIsbnText(e.target.value);
        setShowErrorMessage(false);
        e.preventDefault();
    };

    const onSubmit = () => {
        const isbns = cleanIsbnText(isbnText);

        if (isbns.length > props.maxIsbns) {
            setShowErrorMessage(true);
            const message = `Your list is too large to be added at once. Please reduce your list to a maximum of ${props.maxIsbns} items at a time.`;
            setErrorMessage(message);
        } else if (isbns.length > 0) {
            setAddingItems(true);
            setShowErrorMessage(false);
            //  Send data to PHP side to get book data
            axios.post(`/get-isbn-book-data`, { isbns: isbns }).then((r) => {
                // Send both the original text and the recieved data up to the parent component.
                // Doing this at the same time prevents extra renders.
                props.setIsbnBookData(isbnText, isbns, r.data.data);
                setAddingItems(false);
            });
        } else {
            setShowErrorMessage(true);
            setErrorMessage(`No valid ${props.isbnNamePlural} were found.`);
            inputRef.current.focus();
        }
    };

    useEffect(() => {
        inputRef.current.focus();
    }, []);

    return (
        <React.Fragment>
            <div className="modal-box-body">
                <div>
                    <p className="modal-box-directions">
                        Paste 1 or more items below
                    </p>
                    <div className="modal-box-tooltip" tabIndex={0}>
                        <img
                            className="modal-box-tooltip-icon default"
                            src={ASSET_PATH + questionCircle}
                            alt="Help"
                        />
                        <img
                            className="modal-box-tooltip-icon hover"
                            src={ASSET_PATH + questionCircleHover}
                            alt="Help"
                        />
                        <div className="right">
                            <p>
                                You can paste your {props.isbnNamePlural}{" "}
                                directly from a spreadsheet, email, PDF, or
                                other source. Extraneous text (title, price,
                                etc.) will be filtered out automatically. Up to{" "}
                                {props.maxIsbns} titles can be added at a time;
                                if your list is larger, please break it up and
                                repeat.
                            </p>
                            <i></i>
                        </div>
                    </div>
                </div>
                <textarea
                    ref={inputRef}
                    value={isbnText}
                    onChange={onIsbnTextChange}
                    className={`modal-box-textarea ${
                        showErrorMessage ? "error" : ""
                    }`}
                    placeholder={`Paste a list of ${props.isbnNamePlural} here.`}
                />
                {showErrorMessage ? (
                    <div className="modal-box-error">
                        <img src={ASSET_PATH + warningIcon} alt="Warning" />
                        <div className="modal-box-error-message">
                            {errorMessage}
                        </div>
                    </div>
                ) : null}
            </div>
            <div className="modal-box-footer">
                <button
                    onClick={onSubmit}
                    className="modal-action-btn right add-items"
                    disabled={
                        isbnText.trim() === "" ||
                        showErrorMessage ||
                        addingItems
                    }
                >
                    Add items
                    <img
                        src={ASSET_PATH + rightArrow}
                        alt=""
                        className="right default"
                    />
                    <img
                        src={ASSET_PATH + rightArrow}
                        alt=""
                        className="right hover"
                    />
                </button>
            </div>
        </React.Fragment>
    );
};

export default EnterIsbns;



// WEBPACK FOOTER //
// ./src/components/modal-page/EnterIsbns.js